import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";

const API = window.location.origin + "/api";

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error");
    const errorDesc = searchParams.get("error_description");

    if (error) {
      navigate(`/login?error=${encodeURIComponent(errorDesc || error)}`);
      return;
    }

    if (!code || !state) {
      navigate("/login?error=Paramètres manquants");
      return;
    }

    axios.post(`${API}/auth/microsoft/callback`, { code, state })
      .then(res => {
        setUser(res.data);
        navigate("/dashboard");
      })
      .catch(err => {
        const msg = err.response?.data?.detail || "Erreur d'authentification Microsoft";
        navigate(`/login?error=${encodeURIComponent(msg)}`);
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" style={{ fontFamily: "Manrope, sans-serif" }}>
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600 text-sm">Connexion Microsoft 365 en cours...</p>
      </div>
    </div>
  );
}
